import { render, staticRenderFns } from "./RatingSelect.vue?vue&type=template&id=fab75e04&"
import script from "./RatingSelect.vue?vue&type=script&lang=ts&"
export * from "./RatingSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports